import { createSelector } from 'reselect';

export const getApplication = (state) => state.application;

export const getLogContext = createSelector(
  getApplication,
  (application) => application.logContext
);

export const getApplicationLoaded = createSelector(
  getApplication,
  (application) => application.loaded
);

export const getCimaAuthToken = createSelector(
  getApplication,
  (application) => application.cimaAuthToken
);

export const getDataApiConfig = createSelector(
  getApplication,
  (application) => application.dataApiConfig
);

export const getLoggingBaseUrl = createSelector(
  getDataApiConfig,
  (dataApiConfig) => dataApiConfig.logging.baseUrl
);

export const getTrackingId = createSelector(
  getApplication,
  (application) => application.sessionId
);

export const getLoggerConfig = createSelector(
  [getLogContext, getLoggingBaseUrl, getTrackingId],
  (logContext, baseURL, trackingId) => ({
    appSettings: {
      applicationId: logContext.applicationId,
      apiKey: logContext.apiKey,
      appVersion: process.env.REACT_APP_UI_VERSION,
      loggingEndpoint: {
        baseURL,
      },
    },
    environment: logContext.environment,
    visitorSessionId: trackingId,
  })
);

export const getFidoConfig = createSelector(
  [getDataApiConfig, getLoggerConfig, getTrackingId],
  (dataApiConfig, loggerConfig, trackingId) => {
    const fidoConfig = {
      headers: {
        'tracking-id': trackingId,
      },
      dataApiConfig,
      loggerConfig,
    };

    return fidoConfig;
  }
);
